import { Button } from '@finn/design-system/atoms/button';

import { ComparisonTableFooterLinkAction } from './Action';

export const toSafeLink = (link: string) => {
  if (link.startsWith('http')) {
    return link;
  }
  if (link.startsWith('/de-DE') || link.startsWith('/en-DE')) {
    return link;
  }

  return `/de-DE${link.startsWith('/') ? '' : '/'}${link}`;
};

const LinkFooterAction = ({
  action,
  fullWidth,
}: {
  action: ComparisonTableFooterLinkAction;
  fullWidth?: boolean;
}) => {
  return (
    <Button
      variant="outlineWhite"
      href={toSafeLink(action.href)}
      className={fullWidth ? 'w-full' : ''}
    >
      {action.title}
    </Button>
  );
};

export default LinkFooterAction;
